import React from 'react'
import { Row, Col, Typography, Form, Checkbox, Input } from 'antd'
import { blockSpecialChar, handlingFeeMarkup } from '../../../../../Utilities/numberValidation'

const { Title } = Typography
export const international_services = [
	'International Distribution Freight',
	'International Economy',
	'International Economy Distribution',
	'International Economy Freight',
	'International First',
	'International Priority',
	'International Priority Distribution',
	'International Priority Freight',
	'International Priority Overnight',
	'International Standard Overnight',
	'International Ground',
]

const LabelAs = () => (
	<Col className='gutter-row mb-2' xs={24} sm={24} md={24} lg={24} xl={24}>
	  <label className={'text-gray'}>
		Service name displays by default. Enter an alternative if you prefer
		something different.
	  </label>
	</Col>
  );

const InternationalServices = ({
	quoteSettingsState,
	allCheckHandler,
	internationalcheckAll,
	setInternationalCheckAll,
	onCheck,
	onChange,
}) => {
	return (
		<Col span={8}>
			<Row gutter={30} align='middle' className={'mb-2'}>
				<Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={24}>
					<Title level={5} style={{ textAlign: 'center' }}>
						International Services
					</Title>
				</Col>
			</Row>

			<Row gutter={30} align='middle' className={'mb-2'}>
				<Col span={20}>
					<label className={'text-gray'}>Select All Services</label>
				</Col>
				<Col span={4}>
					<Form.Item className='mb-0'>
						<Checkbox
							name='select_all'
							value={true}
							checked={internationalcheckAll}
							onChange={e =>
								allCheckHandler(
									setInternationalCheckAll,
									e.target.checked,
									international_services,
									''
								)
							}></Checkbox>
					</Form.Item>
				</Col>
			</Row>

			{international_services.map(is => (
				<Row gutter={30} align='middle' className={'mb-2'}>
					<Col span={20}>
						<label className={'text-gray'}>{is}</label>
					</Col>
					<Col span={4}>
						<Form.Item className={'mb-0'}>
							<Checkbox
								name={is.toLowerCase().trim().replaceAll(' ', '_')}
								value={true}
								checked={
									quoteSettingsState?.carrier_services?.[
										is.toLowerCase().trim().replaceAll(' ', '_')
									]
								}
								onChange={onCheck}
							/>
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item className='mb-0'>
							<Input
								value={
									quoteSettingsState?.carrier_services?.[
										is
											.toLowerCase()
											.trim()
											.replaceAll(' ', '_') + '_label'
									]
								}
								name={
									is.toLowerCase().trim().replaceAll(' ', '_') +
									'_label'
								}
								onChange={onChange}
								onKeyDown={blockSpecialChar}
								type='text'
								placeholder={is}
								maxLength={50}
							/>
						</Form.Item>
					</Col>
					<LabelAs />
					<Col span={24} xs={24} sm={24} md={24} lg={24} xl={24}>
						<Form.Item className={'mb-0'}>
							<Input
								//maxLength='7'
								value={
									quoteSettingsState?.carrier_services?.[
										is
											.toLowerCase()
											.trim()
											.replaceAll(' ', '_') + '_markup'
									]
								}
								//pattern='[0-9.?(0-9){2}?]+%?$'
								name={
									is.toLowerCase().trim().replaceAll(' ', '_') +
									'_markup'
								}
								onChange={onChange}
								onKeyDown={handlingFeeMarkup}
								maxLength='7'
								type='text'
							/>
						</Form.Item>
					</Col>

					<Col
						className='gutter-row'
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}>
						<label className={'text-gray'}>
							Markup (e.g Currency 1.00 or percentage 5%)
						</label>
					</Col>
				</Row>
			))}
		</Col>
	)
}

export default InternationalServices

export const new_api_international_services = [
	'International First',
	'International Priority Express',
	'International Priority',
	'International Priority DirectDistribution',
	'International Economy',
	'International Connect Plus',
	'International Ground',
]

const new_api_international_labels = {
	'International First':                   'FedEx International First®',
	'International Priority Express':        'FedEx International Priority® Express',
	'International Priority':                'FedEx International Priority®',
	'International Priority DirectDistribution': 'FedEx International Priority DirectDistribution®',
	'International Economy':                 'FedEx International Economy®',
	'International Connect Plus':            'FedEx® International Connect Plus',
	'International Ground':                  'FedEx International Ground®',
}

export const NewApiInternationalServices = ({ quoteSettingsState, internationalcheckAll, setInternationalCheckAll, allCheckHandler, onCheck, onChange }) => {
	return (
		<Col span={8}>
			<Row gutter={30} align='middle' className={'mb-2'}>
				<Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={24}>
					<Title level={5} style={{ textAlign: 'center' }}>International Services</Title>
				</Col>
			</Row>
			<Row gutter={30} align='middle' className={'mb-2'}>
				<Col span={20}><label className={'text-gray'}>Select All Services</label></Col>
				<Col span={4}>
					<Form.Item className='mb-0'>
						<Checkbox
							name='select_all'
							value={true}
							checked={internationalcheckAll}
							onChange={e => allCheckHandler(setInternationalCheckAll, e.target.checked, new_api_international_services, '')}
						/>
					</Form.Item>
				</Col>
			</Row>
			{new_api_international_services.map(is => {
				const key = is.toLowerCase().trim().replaceAll(' ', '_')
				const label = new_api_international_labels[is] ?? is
				return (
					<Row gutter={30} align='middle' className={'mb-2'} key={key}>
						<Col span={20}><label className={'text-gray'}>{label}</label></Col>
						<Col span={4}>
							<Form.Item className={'mb-0'}>
								<Checkbox
									name={key}
									value={true}
									checked={quoteSettingsState?.carrier_services?.[key]}
									onChange={onCheck}
								/>
							</Form.Item>
						</Col>
						<Col span={24}>
							<Form.Item className='mb-0'>
								<Input
									value={quoteSettingsState?.carrier_services?.[key + '_label']}
									name={key + '_label'}
									onChange={onChange}
									onKeyDown={blockSpecialChar}
									type='text'
									placeholder={label}
									maxLength={50}
								/>
							</Form.Item>
						</Col>
						<Col className='gutter-row mb-2' xs={24} sm={24} md={24} lg={24} xl={24}>
							<label className={'text-gray'}>Service name displays by default. Enter an alternative if you prefer something different.</label>
						</Col>
						<Col xs={24} sm={24} md={24} lg={24} xl={24}>
							<Form.Item className={'mb-0'}>
								<Input
									name={key + '_markup'}
									value={quoteSettingsState?.carrier_services?.[key + '_markup']}
									onChange={onChange}
									onKeyDown={handlingFeeMarkup}
									maxLength='7'
									type='text'
								/>
							</Form.Item>
						</Col>
						<Col xs={24} sm={24} md={24} lg={24} xl={24}>
							<label className={'text-gray'}>Markup (e.g Currency 1.00 or percentage 5%)</label>
						</Col>
					</Row>
				)
			})}
		</Col>
	)
}
